type CookieStorageData = {
  path?: string;
  domain?: string;
  expires?: number;
  sameSite?: 'strict' | 'lax' | 'none';
  secure?: boolean;
};

const cookieDomain = process.env.REACT_APP_COGNITO_COOKIE_DOMAIN?.slice(4); // remove application prefix (kado) from the domain

const config: CookieStorageData = {
  domain: cookieDomain ?? 'localhost',
  secure: !!cookieDomain,
  sameSite: 'strict',
  expires: undefined, // undefined = session
};

export default config;
